function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlower2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg4409",
    viewBox: "0 0 79.374996 79.375002",
    height: 300,
    width: 300,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,-217.62499)",
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1599",
    style: {
      fill: "#c51e25",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "M 33.04379,220.02678 30.8227,236.89591 17.32436,226.538 l -0.0702,-0.0536 c -0.49671,2.08633 -0.36724,4.34269 0.51612,6.47594 2.23061,5.38515 21.78544,25.0183 21.78544,25.0183 0,0 -0.055,-27.71035 -2.286,-33.09515 -0.88336,-2.1336 -2.3869,-3.82058 -4.21429,-4.94453 l -0.0116,0.0878"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1601",
    style: {
      fill: "#c51e25",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 8.1151006,235.74726 10.3575594,13.49869 -16.8687784,2.22109 -0.08784,0.0113 c 1.124303,1.82669 2.811286,3.33058 4.944886,4.21428 5.3844444,2.23062 33.0947844,2.28601 33.0947844,2.28601 0,0 -19.63314,-19.55518 -25.01794,-21.78544 -2.1336,-0.88371 -4.38996,-1.01353 -6.4766444,-0.51612 l 0.05398,0.0702"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1603",
    style: {
      fill: "#c51e25",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 1.6038816,264.49054 16.8687784,2.22109 -10.3575594,13.49869 -0.05362,0.0699 c 2.0866814,0.49671 4.3426914,0.36724 6.4762914,-0.51647 5.3848,-2.23026 25.01794,-21.78508 25.01794,-21.78508 0,0 -27.71069,0.055 -33.0947844,2.28564 -2.1336,0.88406 -3.821289,2.3876 -4.944886,4.21464 l 0.08784,0.0116"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1605",
    style: {
      fill: "#c51e25",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 17.32436,289.41958 13.49834,-10.35791 2.22109,16.86913 0.0116,0.0871 c 1.82739,-1.12431 3.33057,-2.81094 4.21428,-4.94489 2.23061,-5.38445 2.286,-33.09443 2.286,-33.09443 0,0 -19.55518,19.63349 -21.78544,25.01793 -0.88406,2.13325 -1.01317,4.38997 -0.51611,6.47665 l 0.0702,-0.0536"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1607",
    style: {
      fill: "#c51e25",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 46.06764,295.9308 2.22109,-16.86913 13.49833,10.35791 0.0702,0.0533 c 0.49706,-2.08668 0.36724,-4.34234 -0.51647,-6.4763 -2.23026,-5.38444 -21.78508,-25.01793 -21.78508,-25.01793 0,0 0.055,27.71033 2.28529,33.09513 0.88406,2.1336 2.3876,3.82024 4.21464,4.94454 l 0.012,-0.0875"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1609",
    style: {
      fill: "#c51e25",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 70.99668,280.21032 -10.35791,-13.49869 16.86878,-2.22109 0.0878,-0.0116 c -1.12501,-1.82668 -2.81164,-3.33022 -4.94489,-4.21464 -5.38445,-2.22991 -33.09479,-2.28564 -33.09479,-2.28564 0,0 19.6335,19.55517 25.01794,21.78543 2.13396,0.88371 4.38962,1.01353 6.47665,0.51647 l -0.0536,-0.0702"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1611",
    style: {
      fill: "#c51e25",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 77.50755,251.46704 -16.86878,-2.22109 10.35791,-13.49833 0.0533,-0.0706 c -2.08668,-0.49671 -4.34234,-0.36724 -6.4763,0.51612 -5.38444,2.23061 -25.01794,21.78544 -25.01794,21.78544 0,0 27.7107,-0.055 33.09479,-2.28565 2.1336,-0.88336 3.82094,-2.3876 4.94524,-4.21429 l -0.0882,-0.0116"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1613",
    style: {
      fill: "#c51e25",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 61.78742,226.53765 -13.49869,10.35826 -2.22039,-16.86948 -0.0123,-0.0871 c -1.82739,1.12431 -3.33057,2.81094 -4.21463,4.94454 -2.23026,5.38444 -2.28565,33.09479 -2.28565,33.09479 0,0 19.55518,-19.63315 21.78544,-25.0183 0.88406,-2.13325 1.01388,-4.38961 0.51682,-6.47559 l -0.0705,0.0529"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1615",
    style: {
      fill: "#c51e25",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 19.01593,225.4077 4.40373,16.43521 -16.4348594,-4.40408 -0.08502,-0.0229 c 0.33902,2.11773 1.322211,4.15326 2.954509,5.78591 4.1215104,4.12115 29.7014204,14.77681 29.7014204,14.77681 0,0 -10.65494,-25.57992 -14.7768,-29.70107 -1.63265,-1.63301 -3.66748,-2.6162 -5.78555,-2.95522 l 0.0226,0.0854"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1617",
    style: {
      fill: "#c51e25",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 2.0011086,249.47138 14.7344714,8.50724 -14.7344714,8.50723 -0.07691,0.0444 c 1.73743,1.25765 3.872089,2.00131 6.180666,2.00166 5.8285904,0 31.4508404,-10.55334 31.4508404,-10.55334 0,0 -25.62225,-10.553 -31.4504874,-10.553 -2.30893,0 -4.443589,0.74366 -6.181019,2.00201 l 0.07691,0.0438"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1619",
    style: {
      fill: "#c51e25",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 6.9848006,278.51839 16.4348594,-4.40337 -4.40373,16.43486 -0.0226,0.0847 c 2.11808,-0.33902 4.15255,-1.32186 5.78591,-2.95487 4.12115,-4.1215 14.77645,-29.70106 14.77645,-29.70106 0,0 -25.58027,10.65565 -29.7014204,14.77645 -1.632653,1.633 -2.616198,3.66853 -2.954512,5.78661 l 0.08502,-0.0233"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1621",
    style: {
      fill: "#c51e25",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 31.04848,295.53393 8.50723,-14.73518 8.50689,14.73518 0.0445,0.0758 c 1.25836,-1.73743 2.00131,-3.87103 2.00166,-6.18102 0,-5.82789 -10.553,-31.45013 -10.553,-31.45013 0,0 -10.55299,25.6226 -10.55299,31.45048 -2.7e-4,2.30964 0.7433,4.44359 2.00201,6.18103 l 0.0437,-0.0762"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1623",
    style: {
      fill: "#c51e25",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 60.09549,290.54988 -4.40337,-16.43486 16.43451,4.40337 0.085,0.0233 c -0.33902,-2.11843 -1.32186,-4.15325 -2.95522,-5.78626 -4.1208,-4.1208 -29.70071,-14.7768 -29.70071,-14.7768 0,0 10.6553,25.57991 14.77609,29.70141 1.63336,1.63301 3.66818,2.6162 5.78662,2.95557 l -0.0229,-0.0857"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1625",
    style: {
      fill: "#c51e25",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 77.11067,266.48585 -14.73517,-8.50723 14.73517,-8.50724 0.0765,-0.0438 c -1.73778,-1.258 -3.87174,-2.00166 -6.18137,-2.00201 -5.82754,3.5e-4 -31.45014,10.553 -31.45014,10.553 0,0 25.6226,10.55369 31.45014,10.55334 2.30963,0 4.44359,-0.74365 6.18137,-2.00131 l -0.0765,-0.0448"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1627",
    style: {
      fill: "#c51e25",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 72.12663,237.43883 -16.43451,4.40408 4.40337,-16.43521 0.0229,-0.085 c -2.11844,0.33937 -4.15326,1.32221 -5.78626,2.95522 -4.1208,4.12115 -14.77645,29.70072 -14.77645,29.70072 0,0 25.58026,-10.6553 29.70141,-14.77646 1.63301,-1.63265 2.6162,-3.66818 2.95522,-5.7859 l -0.0857,0.0226"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1629",
    style: {
      fill: "#c51e25",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 48.0633,220.4233 -8.50759,14.73553 -8.50723,-14.73553 -0.0437,-0.0762 c -1.25871,1.73779 -2.00166,3.87209 -2.00166,6.18102 0,5.8286 10.55264,31.4505 10.55264,31.4505 0,0 10.55334,-25.6219 10.55334,-31.4505 2.7e-4,-2.30893 -0.7433,-4.44359 -2.00166,-6.18102 l -0.0441,0.0762"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1631",
    style: {
      fill: "#e93e74",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 45.05869,233.68351 -5.50298,9.53277 -5.50333,-9.53277 -0.0286,-0.0487 c -0.81386,1.1236 -1.29505,2.50402 -1.29505,3.99768 0,3.77049 6.82696,20.34611 6.82696,20.34611 0,0 6.82695,-16.57562 6.82695,-20.34611 0,-1.49366 -0.48083,-2.87408 -1.29504,-3.99838 l -0.0289,0.0494"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1633",
    style: {
      fill: "#e93e74",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 26.26869,236.9079 2.84833,10.63237 -10.63202,-2.84938 -0.055,-0.0148 c 0.21943,1.37019 0.85584,2.68711 1.91171,3.74332 2.66629,2.66595 19.21404,9.55923 19.21404,9.55923 0,0 -6.89293,-16.54811 -9.55922,-19.21405 -1.05622,-1.05621 -2.37279,-1.69262 -3.74297,-1.9117 l 0.0152,0.055"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1635",
    style: {
      fill: "#e93e74",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 15.26061,252.47528 9.53241,5.50334 -9.53241,5.50333 -0.049,0.0286 c 1.12395,0.81386 2.50473,1.29505 3.99839,1.29505 3.77049,0 20.34575,-6.82695 20.34575,-6.82695 0,0 -16.57526,-6.82696 -20.34575,-6.82696 -1.49366,0 -2.87444,0.48083 -3.99874,1.29469 l 0.0494,0.0289"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1637",
    style: {
      fill: "#e93e74",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 18.485,271.26669 10.63202,-2.84938 -2.84833,10.63166 -0.0152,0.0554 c 1.37019,-0.21978 2.6864,-0.85549 3.74297,-1.91206 2.6663,-2.66594 9.55922,-19.21368 9.55922,-19.21368 0,0 -16.5481,6.89327 -19.21404,9.55886 -1.05622,1.05622 -1.69227,2.37314 -1.9117,3.74368 l 0.055,-0.0145"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1639",
    style: {
      fill: "#e93e74",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 34.05238,282.27371 5.50333,-9.5324 5.50298,9.5324 0.0289,0.049 c 0.81386,-1.12395 1.29505,-2.50437 1.29505,-3.99874 0,-3.76978 -6.82695,-20.34539 -6.82695,-20.34539 0,0 -6.82696,16.57561 -6.82696,20.34539 0,1.49437 0.48083,2.87514 1.29434,3.99909 l 0.0293,-0.0494"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1641",
    style: {
      fill: "#e93e74",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 52.84273,279.04897 -2.84832,-10.63166 10.63131,2.84938 0.0561,0.0145 c -0.21978,-1.37055 -0.85584,-2.68711 -1.9117,-3.74333 -2.66665,-2.6656 -19.2144,-9.55922 -19.2144,-9.55922 0,0 6.89328,16.54809 9.55922,19.21403 1.05622,1.05622 2.37279,1.69228 3.74298,1.91206 l -0.0152,-0.0557"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1643",
    style: {
      fill: "#e93e74",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 63.85081,263.48195 -9.5324,-5.50333 9.5324,-5.50334 0.0494,-0.0289 c -1.12395,-0.8135 -2.50507,-1.29434 -3.99873,-1.29434 -3.77014,0 -20.34576,6.82661 -20.34576,6.82661 0,0 16.57562,6.8273 20.34576,6.82695 1.49366,2.6e-4 2.87478,-0.48084 3.99908,-1.29469 l -0.0497,-0.0289"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1645",
    style: {
      fill: "#e93e74",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 60.62642,244.69089 -10.63201,2.84938 2.84868,-10.63237 0.0148,-0.0547 c -1.37019,0.21908 -2.68641,0.85549 -3.74297,1.91135 -2.66595,2.6663 -9.55922,19.21405 -9.55922,19.21405 0,0 16.54809,-6.89293 19.21439,-9.55923 1.05622,-1.05586 1.69228,-2.37278 1.9117,-3.74297 l -0.0554,0.0145"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1647",
    style: {
      fill: "#e93e74",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 35.34284,233.42705 -1.43616,10.91282 -8.73266,-6.70031 -0.0455,-0.0353 c -0.32138,1.34972 -0.23742,2.80987 0.33408,4.18994 1.44251,3.48297 14.09312,16.18439 14.09312,16.18439 0,0 -0.0363,-17.92606 -1.47919,-21.40938 -0.5708,-1.38042 -1.54376,-2.47227 -2.72592,-3.19899 l -0.008,0.0568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1649",
    style: {
      fill: "#e93e74",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 19.21702,243.59692 6.69995,8.73266 -10.91283,1.43616 -0.0561,0.008 c 0.72673,1.18181 1.81787,2.15477 3.19794,2.72627 3.48332,1.44322 21.40973,1.47885 21.40973,1.47885 0,0 -12.70142,-12.65026 -16.18439,-14.09348 -1.37971,-0.5715 -2.84021,-0.65546 -4.18994,-0.33372 l 0.0356,0.0455"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1651",
    style: {
      fill: "#e93e74",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 15.00414,262.19149 10.91283,1.43686 -6.70031,8.73196 -0.0349,0.0452 c 1.34973,0.32173 2.80988,0.23813 4.18959,-0.33373 3.48298,-1.44286 16.18439,-14.09311 16.18439,-14.09311 0,0 -17.92676,0.0356 -21.40973,1.47849 -1.38007,0.57185 -2.47156,1.54481 -3.19864,2.72662 l 0.0568,0.008"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1653",
    style: {
      fill: "#e93e74",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 25.17402,278.31837 8.73266,-6.70031 1.43616,10.91212 0.008,0.0568 c 1.18181,-0.72743 2.15477,-1.81857 2.72627,-3.19899 1.44251,-3.48297 1.47884,-21.40937 1.47884,-21.40937 0,0 -12.65061,12.70105 -14.09347,16.18403 -0.5715,1.38077 -0.65511,2.84021 -0.33373,4.19029 l 0.0455,-0.0346"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1655",
    style: {
      fill: "#e93e74",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 43.76823,282.53018 1.43687,-10.91212 8.73231,6.69996 0.0452,0.0349 c 0.32173,-1.35008 0.23812,-2.80952 -0.33373,-4.18994 -1.44286,-3.48333 -14.09312,-16.18438 -14.09312,-16.18438 0,0 0.036,17.92675 1.47849,21.40972 0.5715,1.38007 1.54446,2.47156 2.72697,3.19864 l 0.007,-0.0568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1657",
    style: {
      fill: "#e93e74",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 59.89476,272.36066 -6.7003,-8.73231 10.91317,-1.43686 0.0561,-0.008 c -0.72707,-1.1818 -1.81892,-2.15441 -3.19828,-2.72626 -3.48333,-1.44287 -21.40973,-1.47885 -21.40973,-1.47885 0,0 12.70106,12.65061 16.18439,14.09347 1.38006,0.57185 2.84021,0.65581 4.19029,0.33372 l -0.0356,-0.0451"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1659",
    style: {
      fill: "#e93e74",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 64.10763,253.76574 -10.91317,-1.43616 6.70066,-8.7323 0.0349,-0.0459 c -1.35009,-0.32138 -2.80988,-0.23742 -4.18995,0.33408 -3.48297,1.44287 -16.18438,14.09313 -16.18438,14.09313 0,0 17.9264,-0.0356 21.40938,-1.4785 1.37971,-0.5715 2.47156,-1.54446 3.19898,-2.72626 l -0.0564,-0.008"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1661",
    style: {
      fill: "#e93e74",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 53.93776,237.63886 -8.73266,6.70101 -1.43652,-10.91282 -0.007,-0.0568 c -1.18215,0.72743 -2.15511,1.81857 -2.72697,3.19899 -1.4425,3.48332 -1.47849,21.40938 -1.47849,21.40938 0,0 12.65061,-12.70142 14.09312,-16.18439 0.57185,-1.38007 0.65582,-2.83986 0.33373,-4.18924 l -0.0448,0.0339"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1663",
    style: {
      fill: "#661417",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 45.84257,258.21991 c 0,3.4724 -2.81446,6.28686 -6.28686,6.28686 -3.47204,0 -6.28685,-2.81446 -6.28685,-6.28685 0,-3.4724 2.81481,-6.28721 6.28685,-6.28721 3.4724,0 6.28686,2.81481 6.28686,6.28721"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlower2);
export default __webpack_public_path__ + "static/media/flower-2.3ec70b35ff80cf25b63ffda8a098da97.svg";
export { ForwardRef as ReactComponent };